module.exports = __webpack_public_path__ + "img/logo-small.46a9323c.jpg";